import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Card,
    Input,
    ButtonGroup,
    CardBody,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
export default function CustomCss({
    botSettings,
    saveIntegration,
}) {
    const [inputData, setInputData] = useState(
        {
            text: ""
        }
    );
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.customCss !== null &&
        !botSettings.customCss.isDisabled
    );
    useEffect(() => {
        if (botSettings !== null && botSettings.customCss !== null) {
            setInputData({
                ...botSettings.customCss,
                text: botSettings.customCss.text
            });
        }
        console.log(botSettings.customCss);
    }, [botSettings]);

    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setInputData({
            ...inputData,
            isDisabled: value
        });
    };
    const handleTextChange = (e) => {
        setInputData({ ...inputData, text: e.target.value });
    }
    const handleSave = () => {
        botSettings.customCss = inputData;
        saveIntegration({ botSetting: botSettings });
    }
    return (<Fragment>
        <Card className="mb-4">
            <CardBody name="bodyClick text-center">
                <div className="col-md-12 text-center">
                    <h4>Custom CSS</h4>
                    <p className="mb-4">
                        Use CSS to customize your Digital Compendium
                    </p>
                </div>
                <Separator className="mb-2" />
                <Row>
                    <Colxx xxs="12" className="mt-1">
                        <span className='mr-2'>Enabled</span>
                        <Switch
                            className="custom-switch-primary custom-switch-small"
                            checked={checkedPrimarySmall}
                            onChange={(primary) => handleSwitchChange(primary)}
                        />
                    </Colxx>
                    <Colxx xxs="12" className="mt-3">
                        <span>
                            While most changes can be made with settings in,
                            you may prefer to use CSS to customize further if you have experience writing CSS code.
                        </span><br /><br />
                        <span><b>Type or paste your CSS into the text box provided.</b></span>
                    </Colxx>
                    <Colxx xxs="12" className="mt-3">
                        <Input
                            type="textarea"
                            value={inputData.text}
                            name="text"
                            onChange={(e) => handleTextChange(e)}
                            style={{ height: "100px" }}
                        />
                    </Colxx>
                </Row>
                <Separator className="mt-2 " />
                <div className='d-flex justify-content-center mb-2'>
                    <ButtonGroup className="mb-2 text-center" style={{ marginTop: '40px' }}>
                        <Button color="primary" size="xs" onClick={handleSave}>
                            Save
                        </Button>
                    </ButtonGroup>
                </div>
            </CardBody>
        </Card>
    </Fragment >)
}